// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"93bf877c","723":"9cc1bc2e"}[chunkId] + ".chunk.js";
};